import { ServerResponse } from 'data/types';
import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';

export const API_PATH_DIAMETER = '/diameter';

export const GET_DIAMETER_LIST = 'GET_DIAMETER_LIST';
export const GET_DIAMETER_LIST_PENDING = 'GET_DIAMETER_LIST_PENDING';
export const GET_DIAMETER_LIST_FULFILLED = 'GET_DIAMETER_LIST_FULFILLED';

export type Diameter = {
  id: string
  dsid: string
  interfaceValue: string
  niid: string
  port: string
  orighost: string
  origrealm: string
  secinfoid: string
  encryption: string
}

export type DiameterState = {
  entities: Diameter[],
};

export interface GetDiameterListAction extends AnyAction {
  type: typeof GET_DIAMETER_LIST
  payload: AxiosPromise<ServerResponse<Diameter>>
}

export interface GetDiameterListPendingAction extends AnyAction {
  type: typeof GET_DIAMETER_LIST_PENDING
  payload: null
}

export interface GetDiameterstFulfilledAction extends AnyAction {
  type: typeof GET_DIAMETER_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<Diameter>>
}

export type DiameterActionTypes =
  GetDiameterListAction |
  GetDiameterListPendingAction |
  GetDiameterstFulfilledAction;
